import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import { CollectorsApi, MailApi, SellersApi } from '~/api';
export var state = function state() {
	return {
		createNewSeller: false,
		showTable: false
	};
};

export var getters = {
	modalNewSeller: function modalNewSeller(state) {
		return state.createNewSeller;
	}
};

export var mutations = {
	setShowTable: function setShowTable(state, data) {
		state.showTable = data;
	}
};

export var actions = {
	downloadChargeSeller: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var state = _ref.state;
			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							return _context.abrupt('return', new CollectorsApi(this.$axios).chargeSellerModel({}));

						case 1:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		function downloadChargeSeller(_x) {
			return _ref2.apply(this, arguments);
		}

		return downloadChargeSeller;
	}(),
	readChargeSeller: function () {
		var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, file) {
			var state = _ref3.state;
			return _regeneratorRuntime.wrap(function _callee2$(_context2) {
				while (1) {
					switch (_context2.prev = _context2.next) {
						case 0:
							return _context2.abrupt('return', new CollectorsApi(this.$axios).readSellerModel({ file: file }));

						case 1:
						case 'end':
							return _context2.stop();
					}
				}
			}, _callee2, this);
		}));

		function readChargeSeller(_x2, _x3) {
			return _ref4.apply(this, arguments);
		}

		return readChargeSeller;
	}(),
	chargeSeller: function chargeSeller(_ref5, _ref6) {
		var state = _ref5.state,
		    rootState = _ref5.rootState;
		var sellers = _ref6.sellers;

		return new SellersApi(this.$axios).chargeSeller({ sellers: sellers, idChannel: rootState.team.idChannel });
	},
	sendMailErrorsCharge: function () {
		var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7, errors) {
			var rootState = _ref7.rootState;
			return _regeneratorRuntime.wrap(function _callee3$(_context3) {
				while (1) {
					switch (_context3.prev = _context3.next) {
						case 0:
							return _context3.abrupt('return', new MailApi(this.$axios).sendSummaryMailErrors({
								to: '' + rootState.user.email,
								name: rootState.user.firstName + ' ' + rootState.user.lastName,
								errors: errors
							}));

						case 1:
						case 'end':
							return _context3.stop();
					}
				}
			}, _callee3, this);
		}));

		function sendMailErrorsCharge(_x4, _x5) {
			return _ref8.apply(this, arguments);
		}

		return sendMailErrorsCharge;
	}()
};


//////////////////
// WEBPACK FOOTER
// ./src/store/collaborators/teams.js
// module id = ./src/store/collaborators/teams.js
// module chunks = 34